const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
const K = 1024;

// Chart.js calls tick callbacks for every grid line — including ones below zero
// when the dataset has any negative-leaning padding. Guard against non-finite
// and negative inputs so they don't render as "NaN undefined".
export default function formatBytesTick(value) {
  if (!Number.isFinite(value) || value < 0) return '';
  if (value === 0) return '0 B';

  const i = Math.min(Math.floor(Math.log(value) / Math.log(K)), UNITS.length - 1);
  const formatted = value / Math.pow(K, i);

  if (value >= 100 * Math.pow(K, 3)) {
    return `${formatted.toFixed(2)} ${UNITS[i]}`;
  }
  return `${formatted % 1 === 0 ? formatted : formatted.toFixed(1)} ${UNITS[i]}`;
}
